<template>
    <button type="button" class="timesheet-row-remove" :disabled="disabled"
        :aria-label="`Убрать из табеля: ${name}`" @click.stop="$emit('exclude')">
        Убрать из табеля
    </button>
</template>

<script>
export default {
    props: {name: {type: String, default: ''}, disabled: Boolean}
};
</script>

<style>
.timesheet-page .timesheet-row-remove {
    display: block; width: fit-content; max-width: 100%; min-height: 32px;
    margin: 5px 0 0; padding: 5px 8px;
    border: 1px solid #c89692; border-radius: 6px;
    color: #923b35; background: #fff6f4;
    font: inherit; font-size: 12px; font-weight: 600; line-height: 1.3;
    text-align: left; white-space: normal; cursor: pointer;
}
.timesheet-page .timesheet-row-remove:hover:not(:disabled) { color: #752c27; background: #ffe9e4; border-color: #a96158; }
.timesheet-page .timesheet-row-remove:focus-visible { outline: 2px solid #247bb8; outline-offset: 2px; }
.timesheet-page .timesheet-row-remove:disabled { opacity: .55; cursor: default; }
</style>